import _extends from "@babel/runtime/helpers/extends";
import { useEffect, useRef } from "react";
import Guide from "../index";
var GuideModal = function GuideModal(props) {
  var options = props.options,
    highlight = props.highlight,
    defineSteps = props.defineSteps,
    highlightAlert = props.highlightAlert;
  var guideObj = useRef(null);
  useEffect(function () {
    guideObj.current = new Guide(_extends({
      mask: false,
      allowClose: false,
      position: "right",
      doneBtnText: "知道了"
    }, options));
    if (highlight) {
      guideObj.current.highlight(highlight);
    }
    if (highlightAlert) {
      guideObj.current.highlightAlert(highlightAlert);
    }
    if (defineSteps && defineSteps.length) {
      guideObj.current.defineSteps(defineSteps);
      guideObj.current.start();
    }
    return function () {
      guideObj && guideObj.current.destory();
      guideObj.current = null;
    };
  }, [options, highlight, defineSteps, highlightAlert]);
  return null;
};
export default GuideModal;